<template>
  <div class="mypage-ticket-list-section">
    <template v-if="purchasedDigitalTickets && purchasedDigitalTickets.length > 0">
      <ul>
        <li
          v-for="ticketEvent in purchasedDigitalTickets"
          :key="ticketEvent.uniqueKey"
          class="mypage-ticket-list-section__item"
        >
          <mypage-ticket-block-section :ticketEvent="ticketEvent" />
        </li>
      </ul>
    </template>
    <template v-else>
      <p
        class="mypage-ticket-list-section__no-data"
        v-html="$tc('MypagePage.MypageTicketListPage.noTickets')"
      ></p>
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api'
import MypageTicketBlockSection from '@/components/MypageTicketListPage/MypageTicketListPane/MypageTicketBlockSection.vue'
import DigitalTicketDataDocument from '@/store/stores/collectionModule/documents/digitalTicket/DigitalTicketDataDocument'

/**
 * マイページ: チケット一覧セクション
 */
export default defineComponent({
  name: 'MypageTicketListSection',
  components: {
    MypageTicketBlockSection,
  },
  props: {
    purchasedDigitalTickets: {
      type: Array as PropType<Array<DigitalTicketDataDocument>>,
    },
  },
})
</script>
<style scoped lang="scss">
.mypage-ticket-list-section {
  &__no-data {
    padding: 7px 0;
    font-family: $fontSignup;
    font-weight: 500;
    font-size: 12px;
    line-height: 1.67;
    text-align: center;
    letter-spacing: 0.02em;
    font-feature-settings: 'palt' on;
    color: $gray50;
  }
}
</style>
